var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"draggable",staticClass:"absolute cursor-pointer rounded-lg z-40",class:[_vm.borderClass],style:({ left: _vm.x + 'px', top: _vm.y + 'px' }),on:{"mousedown":_vm.startDrag}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }